"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberOrZero = exports.formatNumber = exports.getDividerLabel = exports.getDivider = void 0;
const getDivider = (maxValue) => {
    if (maxValue === undefined) {
        return undefined;
    }
    if (maxValue >= 1000000000) {
        return 1000000;
    }
    if (maxValue >= 1000000) {
        return 1000;
    }
    return 1;
};
exports.getDivider = getDivider;
const getDividerLabel = (divider) => divider === 1000000 ? "M" : divider === 1000 ? "k" : "";
exports.getDividerLabel = getDividerLabel;
const formatNumber = (value, digits) => value !== undefined
    ? value?.toLocaleString("en-US", digits !== undefined ? { maximumFractionDigits: digits } : undefined)
    : undefined;
exports.formatNumber = formatNumber;
const numberOrZero = (value) => typeof value === "number" && Number.isFinite(value) ? value : 0;
exports.numberOrZero = numberOrZero;
